import styled from 'styled-components';

export const StatusNameEditorContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -3px;
`;
export const MessageFooterStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StatusNameStyled = styled.div`
  margin: 8px;
`;
export const StatusHelperMessageStyled = styled.div<{
  isValid?: boolean;
}>`
  font-size: 12px;
  color: ${({ isValid }) =>
    isValid
      ? 'var(--ds-text-subtlest, var(--ds-fb-text-subtlest))'
      : 'var(--ds-text-danger, var(--ds-fb-text-danger))'};
`;
